import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

// localStorage-backed persister for the React Query cache. Synchronous storage
// is fine here — the cached payloads (home banners/courses lists) are small.
// SSR-safe: window is guarded so this module can be imported anywhere.
export const queryPersister = createSyncStoragePersister({
  storage: typeof window !== "undefined" ? window.localStorage : undefined,
  key: "amoozim-query-cache",
});

// Restored caches older than this are discarded. Keep <= queryClient gcTime.
export const PERSIST_MAX_AGE = 1000 * 60 * 60 * 24; // 24h

// Bump to invalidate every persisted cache at once (e.g. after an API shape
// change). Tied to the app version so a deploy never serves stale shapes.
export const PERSIST_BUSTER = import.meta.env.VITE_APP_VERSION ?? "v2";
